import React, { Component } from "react";
import { connect } from "react-redux";

import _ from "i18n";
import { getClientThemes } from "TamtamAPI";
import { ThemeCard } from "../../ui/ThemeCard";
import { ThemeCardFetching } from "../../fetching/ThemeCardFetching";
import NotFound from "../../notFound/NotFound";
import SearchBox from "../../common/filter/SearchBox";
import TTPTab from "../../ui/tabs/TTPTab";
import { setCurrentEmailCampaignData } from "../../../actions/actions/currentCampaign";
import {
  COMMUNITY_SCOPE,
  TAMTAM_SCOPE,
  SHARED_MODELS_SCOPE,
  TEMPLATE_TYPES,
} from "../../../constants";
import StepsFooter from "./StepsFooter";
import { SVG_SIMPLE_CHECK_ICON } from "../../../services/svgIcones";
import { setTTPDialogCustomData } from "../../../actions/actions/params";
import { onSuccess } from "../../../services/utils";

const RICH_TEXT_DEFAULT_THEMES = {
  4: { en: 13012, nl: 13013, fr: 12881 }, // DEG
  1256: { en: 12985, nl: 12987, fr: 12176 }, // Ordre
  9: { en: 9942, nl: 9942, fr: 9942 }, // FFF
  17036: { en: 12985, nl: 12987, fr: 12176 }, // Fid test
  10771: { en: 12985, nl: 12987, fr: 12176 }, // Ede
  22255: { en: 14236, nl: 14236, fr: 14236 }, // TwinnTax
};

const SCOPE_TABS = [
  { id: COMMUNITY_SCOPE, label: "my models" },
  { id: SHARED_MODELS_SCOPE, label: "shared" },
  { id: TAMTAM_SCOPE, label: "library" },
];

const mapStateToProps = (store) => ({
  token: store.auth.token,
  clientId: store.auth.currentClient.id,
  userId: store.auth.loggedAs === "ADMIN" ? null : store.auth.user.id,
  currentStep: store.currentCampaign.email.currentSideBar === "MODELS",
  selectedThemeId: store.currentCampaign.email.themeId,
  language: store.currentCampaign.email.language,
});

const mapDispatchToProps = (dispatch) => ({
  setCurrentCampaign: (data) => dispatch(setCurrentEmailCampaignData(data)),
  setTTPDialogCustomData: (data) => dispatch(setTTPDialogCustomData(data)),
});

class ModelsTextStep extends Component {
  constructor(props) {
    super(props);
    this.state = {
      samples: [],
      fetching: false,
      searchWord: "",
      scope: COMMUNITY_SCOPE,
    };
  }

  componentDidMount() {
    this.fetchModels();
    this.applyDefaultTheme();
  }

  componentDidUpdate() {
    if (!this.props.selectedThemeId) {
      this.applyDefaultTheme();
    }
  }

  getDefaultThemeId = () => {
    const { clientId, language } = this.props;
    const group = RICH_TEXT_DEFAULT_THEMES[clientId];
    if (!group) return null;
    const lng = (language || "fr").toLowerCase();
    return group[lng] || group.fr;
  };

  applyDefaultTheme = () => {
    if (this.props.selectedThemeId) return;
    const defaultThemeId = this.getDefaultThemeId();
    if (defaultThemeId) {
      this.props.setCurrentCampaign({ themeId: defaultThemeId });
    }
  };

  fetchModels = () => {
    const { token, clientId, userId } = this.props;
    const { scope, searchWord } = this.state;
    this.setState({ fetching: true });
    getClientThemes(
      token,
      clientId,
      {
        type: [TEMPLATE_TYPES.SIMPLE, TEMPLATE_TYPES.WRAPPER],
        scope,
        isBlock: true,
        searchWord,
      },
      userId,
    )
      .then((res) => {
        this.setState({ samples: res?.data?.data || [], fetching: false });
      })
      .catch(() => this.setState({ fetching: false }));
  };

  handleSearchChange = (searchWord) => {
    this.setState({ searchWord }, this.fetchModels);
  };

  switchScope = (scope) => {
    if (scope === this.state.scope) return;
    this.setState({ scope, samples: [] }, this.fetchModels);
  };

  applyTheme = (theme) => {
    this.props.setCurrentCampaign({ themeId: theme.id });
    onSuccess(null, { body: "themeApplied", title: "successfulAction" });
  };

  handleSelectTheme = (theme) => {
    const { selectedThemeId, setTTPDialogCustomData } = this.props;
    if (selectedThemeId && String(selectedThemeId) !== String(theme.id)) {
      setTTPDialogCustomData({
        approvedAction: () => this.applyTheme(theme),
        message: _("confirmSwitchTheme"),
        title: "Confirmation of switching models",
      });
    } else {
      this.applyTheme(theme);
    }
  };

  render() {
    const { currentStep, selectedThemeId } = this.props;
    const { samples, fetching, scope } = this.state;

    const uniqueSamples = samples.filter(
      (theme, index, list) =>
        list.findIndex((t) => t.id === theme.id) === index,
    );

    const isSelected = (id) => String(id) === String(selectedThemeId);

    const orderedSamples = [
      ...uniqueSamples.filter((t) => isSelected(t.id)),
      ...uniqueSamples.filter((t) => !isSelected(t.id)),
    ];

    return (
      <div id="send-tabs__tab" className={`${!currentStep && "hide"}`}>
        <div className="tab models-text-step">
          <div className="models-text-step__toolbar">
            <TTPTab
              tabs={SCOPE_TABS}
              type="simple"
              activeTab={scope}
              selectTab={this.switchScope}
            />
            <SearchBox onChange={this.handleSearchChange} />
          </div>
          <div className="models-text-step__container">
            <div className="row">
              {orderedSamples.length > 0
                ? orderedSamples.map((theme) => (
                    <div key={theme.id} className="columns small-4">
                      <div
                        className={`models-text-step__card ${
                          isSelected(theme.id) ? "is-applied" : ""
                        }`}
                      >
                        {isSelected(theme.id) && (
                          <span className="models-text-step__applied-badge">
                            <span className="check">
                              {SVG_SIMPLE_CHECK_ICON}
                            </span>
                            {_("Applied")}
                          </span>
                        )}
                        <ThemeCard
                          {...theme}
                          isActive={isSelected(theme.id)}
                          onSelect={() => this.handleSelectTheme(theme)}
                        />
                      </div>
                    </div>
                  ))
                : !fetching && (
                    <NotFound
                      text={_("Oops, no templates were found.")}
                      mainClass="small-10"
                    />
                  )}
              {fetching &&
                [1, 2, 3, 4, 5, 6].map((index) => (
                  <div
                    key={"theme-fetching-" + index}
                    className="columns small-4"
                  >
                    <ThemeCardFetching />
                  </div>
                ))}
            </div>
          </div>
        </div>

        <StepsFooter
          disabled={!selectedThemeId}
          currentPage={this.props.currentPage}
        />
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ModelsTextStep);
